import { toDegrees, toRadians } from "./modules/Utils";

export type IVector2 = {
    x: number;
    y: number;
};

export function dot(v1: IVector2, v2: IVector2) {
    return v1.x * v2.x + v1.y * v2.y;
}

export function radiansBetweenVectors(v1: IVector2, v2: IVector2) {
    return Math.acos(dot(v1, v2));
}

export function degreesBetweenVectors(v1: IVector2, v2: IVector2) {
    return toDegrees(radiansBetweenVectors(v1, v2));
}

export function bearingToUnitVector(bearing: number) {
    const r = toRadians(bearing);
    return {
        x: Math.sin(r),
        y: Math.cos(r),
    };
}
